import React, { useEffect, useState } from 'react';
import "./Navbar.css";
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo/logo.png';
import { RiShoppingCart2Line, RiMenuFill, RiCloseLine, RiListUnordered, RiMailFill } from "react-icons/ri";
import { useProducts } from '../../Context/ProductProvider';
import Loading from '../../pages/Loading/Loading';
import User from './User';
import CategoriesItem from './CategoriesItem';
import { Toaster } from 'react-hot-toast';
import { useQuery } from 'react-query';
import HomeLoading from '../../pages/Loading/HomeLoading';

const Navbar = ({ children }) => {

    const [showNotificationDetails, setShowNotificationDetails] = useState({})


    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const { state: { cart }, loading, error } = useProducts();
    const { data, isLoading, isError, refetch } = useQuery("mobileNotification", () => fetch(`${process.env.REACT_APP_SECRET_API}/user/notification`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()), {
        staleTime: 1500, // set staleTime to 1 second
        refetchInterval: 3000 // fetch new data every 10 seconds
    });



    let content;

    if (loading || isLoading) {
        return <HomeLoading></HomeLoading>
    }
    if (error || isError) {
        content = <h1>Something went wrong</h1>
    }

    const notification = data?.data;
    const unreadNotifications = notification ? notification.filter(item => item?.mark_as_read === 0) : [];
    const unreadNotificationCount = unreadNotifications.length;
    const showNotificationModelItem = async (id) => {

        await fetch(`${process.env.REACT_APP_SECRET_API}/user/notification/${id}`, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                'content-type': "application/json",
                'authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.json())
            .then(data => {
                setShowNotificationDetails(data)

            })
        refetch();
    }



    return (
        <div>
            <div className='bg-white'>
                <header className="container py-5">
                    <div className="flex items-center justify-between">
                        {/* logo */}
                        <Link to="/" className="block w-32">
                            <img src={logo} alt="logo" className="w-full" />
                        </Link>
                        {/* logo end */}

                        {/*  nav icons */}
                        <div className="space-x-4 flex items-center">
                            <Link to="wishlist.html" className="hidden text-center text-gray-700 hover:text-primary transition relative">
                                <span
                                    className="absolute -right-0 -top-1 w-5 h-5 rounded-full flex items-center justify-center bg-primary text-white text-xs">5</span>
                                <div className="text-2xl">
                                    <i className="far fa-heart"></i>
                                </div>
                                <div className="text-xs leading-3">Wish List</div>
                            </Link>
                            <Link to="/cart"
                                className="lg:block text-center pr-3 text-gray-700 hover:text-primary transition hidden relative">
                                <span
                                    className="absolute -right-0 -top-1 w-5 h-5 rounded-full flex items-center justify-center bg-primary text-white text-xs">{cart?.length} {content}</span>
                                <div className="text-2xl">
                                    <RiShoppingCart2Line />
                                </div>
                            </Link>
                            {!token && !token ?
                                <Link to="/sign-up" className="block text-center text-gray-700 hover:text-primary transition">
                                    <div className="text-2xl font-bold text-primary">
                                        Sign Up
                                    </div>
                                </Link>
                                : ""}


                        </div>
                        {/* nav icons end */}

                    </div>
                </header>
            </div>
            {/* header end */}

            {/* navbar */}
            <nav className="bg-primary hidden lg:block">
                <div className="container">
                    <div className="flex">
                        {/* all category */}
                        <div className="px-8 py-4 bg-gray-800 flex items-center cursor-pointer group relative">
                            <span className="text-white">
                                <RiMenuFill />
                            </span>
                            <span className="capitalize ml-2 text-white">All categories</span>

                            <div className="absolute left-0 top-full w-full bg-white shadow-md pt-3 invisible opacity-0 group-hover:opacity-100 group-hover:visible transition duration-300 z-50  divide-y divide-gray-300 divide-dashed">
                                {/* single category */}
                                <CategoriesItem />
                                {/* <Link to="#" className="px-6 py-3 flex items-left hover:bg-gray-100 transition">
                                    <span className="ml-6 text-gray-600 text-sm">Bedroom</span>
                                </Link> */}
                                {/* single category end */}

                                {/* single category end */}
                            </div>
                        </div>

                        {/* all category end */}

                        {/* nav menu */}
                        <div className="flex items-center justify-between flex-grow pl-12">
                            <div className="flex items-center space-x-6 text-base capitalize">
                                <Link to="/" className="text-white hover:text-gray-200 transition">Home</Link>
                                <Link to="/shop" className="text-white hover:text-gray-200 transition">Shop</Link>
                                <Link to="/products" className="text-white hover:text-gray-200 transition">Products</Link>
                                <Link to="/campaign-list" className="text-white hover:text-gray-200 transition">Campaign</Link>
                                {/* <Link to="#" className="text-white hover:text-gray-200 transition">Contact us</Link> */}
                            </div>
                            <div className='relative'>
                                <User />
                                <span
                                    className="absolute  -top-1 lg:right-0 -right-2 w-5 h-5 rounded-full flex items-center justify-center bg-white text-black text-xs">
                                    {unreadNotificationCount}
                                </span>
                            </div>
                        </div>
                        {/* nav menu end */}

                    </div>
                </div>
            </nav>

            {/* mobile menubar  */}
            <div
                className="fixed w-full border-t border-gray-200 shadow-sm bg-primary py-3 bottom-0 left-0 flex justify-around items-start px-6 lg:hidden z-40">
                <button onClick={toggleMobileMenu} className="block text-center text-white hover:text-gray-300 transition relative">
                    <div className="text-2xl">
                        <RiMenuFill />
                    </div>
                    <div className="text-xs leading-3">Menu</div>
                </button>
                <button onClick={() => navigate("/all-category")} className="block text-center text-white hover:text-gray-300 transition relative">
                    <div className="text-2xl">
                        <RiListUnordered />
                    </div>
                    <div className="text-xs leading-3">Category</div>
                </button>
                {/* ====== */}
                <label htmlFor="my-modal-3" className="block text-center text-white hover:text-gray-300 transition relative">
                    <div className="text-2xl">
                        <RiMailFill />

                    </div>
                    <div className="text-xs leading-3">Ibx</div>
                    <span
                        className="absolute  -top-1 lg:right-0 -right-2 w-5 h-5 rounded-full flex items-center justify-center bg-white text-black text-xs">
                        {unreadNotificationCount}
                    </span>
                </label>

                <button className="block text-center text-white hover:text-gray-300 transition relative">
                    <User />
                    <div className="text-xs leading-3">User</div>
                </button>
                <Link to="/cart" className="text-center text-white hover:text-gray-300 transition relative">
                    <span
                        className="absolute -right-3 -top-1 w-5 h-5 rounded-full flex items-center justify-center bg-white text-black text-xs">{cart?.length} {content}</span>
                    <div className="text-2xl">
                        <RiShoppingCart2Line />
                    </div>
                    <div className="text-xs leading-3">Cart</div>
                </Link>
            </div>
            {/* mobile menubar end  */}

            {/* mobile sidebar menu  */}
            <div className={`fixed left-0 top-0 w-full h-full z-50 shadow mobile-menu ${isMobileMenuOpen ? "open" : ""}`} id="mobileMenu" onClick={toggleMobileMenu}>
                <div className="absolute left-0 top-0 w-72 h-full z-50 bg-white shadow">
                    <div onClick={toggleMobileMenu}
                        className="text-gray-400 hover:text-primary text-lg absolute right-3 top-3 cursor-pointer">
                        <RiCloseLine />
                    </div>
                    {/* nav link  */}
                    <h3 className="text-xl font-semibold text-gray-700 mb-1 font-roboto pl-4 pt-4">Menu</h3>
                    <div className="">
                        <Link to="/" className="block px-4 py-2 font-medium transition hover:bg-gray-100">
                            Home
                        </Link>
                        <Link to="/shop" className="block px-4 py-2 font-medium transition hover:bg-gray-100">
                            Shop
                        </Link>
                        <Link to="/products" className="block px-4 py-2 font-medium transition hover:bg-gray-100">
                            Products
                        </Link>
                        <Link to="/campaign-list" className="block px-4 py-2 font-medium transition hover:bg-gray-100">
                            Campaign
                        </Link>
                    </div>
                    {/* nav links end  */}
                </div>
            </div>
            {/* mobile sidebar menu end */}




            <input type="checkbox" id="my-modal-3" className="modal-toggle" />
            <div className="modal w-full shadow-none">
                <div className="modal-box max-w-full">
                    <label htmlFor="my-modal-3" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    {/* Notification */}

                    {notification?.map(item => (
                        // {item?.mark_as_read ===0 ? "" : ""}
                        <div key={item?.id} className={`alert flex-row shadow ${item?.mark_as_read === 0 ? "bg-white" : ""} my-3 rounded-none`}>
                            {item?.mark_as_read === 0 ?
                                (
                                    <div className=''>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                        <div>
                                            <h3 className="font-bold">New message!</h3>
                                            <div className="text-xs">{item?.message}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className=''>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                        <div>
                                            <h3 className="font-bold">Already Open</h3>
                                            <div className="text-xs">{item?.message}</div>
                                        </div>
                                    </div>
                                )}

                            <div className="flex-none">
                                {/* <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button> */}
                                <label htmlFor="details_modal" onClick={() => showNotificationModelItem(item?.id)} className="btn btn-xs" style={{ borderRadius: "5px" }}>See</label>
                            </div>
                        </div>
                    ))}
                </div>

                <input type="checkbox" id="details_modal" className="modal-toggle" />
                <label htmlFor="details_modal" className="modal cursor-pointer">

                    <div className="flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow md:flex-row md:max-w-xl hover:bg-gray-100 ">
                        <div className="flex flex-col justify-between p-4 leading-normal">
                            <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{showNotificationDetails?.data?.message}</p>
                        </div>
                    </div>
                </label>
            </div>
            <Toaster />
            {children}
        </div>
    );
};

export default Navbar;